/**
 * Comportamiento del menú en el front-end: paneles (menú, buscador, ingresar)
 * y acordeón de secciones. Solo un panel puede estar abierto a la vez.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

const OPEN_CLASS = 'sc-new-menu--open';
const BODY_CLASS = 'sc-new-menu-locked';

// Widget externo del simulador de crédito (mismo patrón que blocks/src/sc-menu/view.js).
const createVisor = () => {
	if ( ! document.getElementById( 'Simulador' ) ) {
		const visor = `<app-visor
			id="Simulador"
			app="Simulador"
			options='{
			"openModal":"true",
			"buttonFloating": "true",
			"defaultButtonHidden": "true",
			"externalPageRedirection": "true",
			"storeId":"621ed5f9461ca80001719952",
			"iframeSize":"80,-40"
			}'
		></app-visor>`;
		const parser = new DOMParser();
		const doc = parser.parseFromString( visor, 'text/html' );
		document.body.appendChild( doc.body.firstChild );
	}
};

function showsimulador() {
	document.dispatchEvent( new CustomEvent( 'sc:visor:open', { detail: 'Simulador' } ) );
}
window.showsimulador = showsimulador;

document.addEventListener( 'click', ( event ) => {
	if ( event.target.getAttribute( 'href' ) === 'javascript:showsimulador()' ) {
		event.preventDefault();
		showsimulador();
	}
} );

function getContent( root, trigger ) {
	const id = trigger.getAttribute( 'aria-controls' );
	return id ? root.querySelector( `#${ CSS.escape( id ) }` ) : null;
}

function closeAccordions( root ) {
	root.querySelectorAll( '.sc-new-menu__nav-trigger' ).forEach( ( trigger ) => {
		const content = getContent( root, trigger );
		trigger.setAttribute( 'aria-expanded', 'false' );
		if ( content ) {
			content.hidden = true;
		}
	} );
}

function closePanels( root ) {
	root.classList.remove( OPEN_CLASS );
	root.removeAttribute( 'data-sc-active' );
	root.removeAttribute( 'data-sc-active-nav' );
	document.body.classList.remove( BODY_CLASS );

	root.querySelectorAll( '[data-sc-panel]' ).forEach( ( button ) => {
		button.setAttribute( 'aria-expanded', 'false' );
	} );
	root.querySelectorAll( '[data-sc-desktop-nav]' ).forEach( ( button ) => {
		button.setAttribute( 'aria-expanded', 'false' );
	} );
	root.querySelectorAll( '[data-sc-panel-content]' ).forEach( ( panel ) => {
		panel.hidden = true;
	} );

	const overlay = root.querySelector( '[data-sc-overlay]' );
	if ( overlay ) {
		overlay.hidden = true;
	}

	closeAccordions( root );
}

function openPanel( root, name ) {
	closePanels( root );

	const panel = root.querySelector( `[data-sc-panel-content="${ name }"]` );
	const triggers = root.querySelectorAll( `[data-sc-panel="${ name }"]` );
	if ( ! panel || ! triggers.length ) {
		return;
	}

	root.classList.add( OPEN_CLASS );
	root.setAttribute( 'data-sc-active', name );
	document.body.classList.add( BODY_CLASS );
	panel.hidden = false;
	triggers.forEach( ( trigger ) => trigger.setAttribute( 'aria-expanded', 'true' ) );

	const overlay = root.querySelector( '[data-sc-overlay]' );
	if ( overlay ) {
		overlay.hidden = false;
	}

	if ( name === 'search' ) {
		const input = panel.querySelector( '.sc-new-menu__search-input' );
		if ( input ) {
			input.focus();
		}
	}
}

function setupAccordion( root ) {
	root.querySelectorAll( '.sc-new-menu__nav-trigger' ).forEach( ( trigger ) => {
		trigger.addEventListener( 'click', () => {
			const content = getContent( root, trigger );
			const isOpen = trigger.getAttribute( 'aria-expanded' ) === 'true';

			closeAccordions( root );

			if ( ! isOpen && content ) {
				trigger.setAttribute( 'aria-expanded', 'true' );
				content.hidden = false;
			}
		} );
	} );
}

function setupDesktopNav( root ) {
	root.querySelectorAll( '[data-sc-desktop-nav]' ).forEach( ( button ) => {
		button.addEventListener( 'click', () => {
			const id = button.getAttribute( 'data-sc-desktop-nav' );
			if ( root.getAttribute( 'data-sc-active-nav' ) === id ) {
				closePanels( root );
				return;
			}

			openPanel( root, 'nav' );

			const content = root.querySelector( `#${ CSS.escape( `${ id }-content` ) }` );
			const trigger = root.querySelector( `#${ CSS.escape( `${ id }-trigger` ) }` );
			if ( content ) {
				content.hidden = false;
			}
			if ( trigger ) {
				trigger.setAttribute( 'aria-expanded', 'true' );
			}
			button.setAttribute( 'aria-expanded', 'true' );
			root.setAttribute( 'data-sc-active-nav', id );
		} );
	} );
}

function setupMenu( root ) {
	root.querySelectorAll( '[data-sc-panel]' ).forEach( ( button ) => {
		button.addEventListener( 'click', () => {
			const name = button.getAttribute( 'data-sc-panel' );
			if ( root.getAttribute( 'data-sc-active' ) === name ) {
				closePanels( root );
				return;
			}
			openPanel( root, name );
		} );
	} );

	const overlay = root.querySelector( '[data-sc-overlay]' );
	if ( overlay ) {
		overlay.addEventListener( 'click', () => closePanels( root ) );
	}

	document.addEventListener( 'keydown', ( event ) => {
		if ( event.key === 'Escape' ) {
			closePanels( root );
		}
	} );

	setupAccordion( root );
	setupDesktopNav( root );
	closePanels( root );
}

document.addEventListener( 'DOMContentLoaded', () => {
	const menus = document.querySelectorAll( '[data-sc-new-menu]' );
	if ( menus.length ) {
		createVisor();
	}
	menus.forEach( setupMenu );
} );

